import { createInertiaApp } from "@inertiajs/svelte"
import { hydrate, mount } from "svelte"
import { waitLocale } from "svelte-i18n"

import { initAnalyticsEvents } from "@/lib/analytics"
import { initialLocaleFromPage, setupClientI18n } from "@/lib/i18n"
import { reloadOnStaleChunk } from "@/lib/reload-on-stale-chunk"
import { resolvePage } from "@/lib/resolve-page"
import { initializeTheme } from "@/runes/use-appearance.svelte"

reloadOnStaleChunk()

// The server rendered in the request's locale, so that locale's messages
// must be loaded BEFORE hydration — hydrating with the English fallback
// would mismatch the SSR HTML and flash-rerender the page. For English
// (bundled statically) waitLocale resolves immediately. If the locale
// chunk fails to load, boot anyway: English hydration beats a dead page.
setupClientI18n(initialLocaleFromPage())

await waitLocale().catch(() => {})

initAnalyticsEvents()

createInertiaApp({
  resolve: resolvePage,

  setup({ el, App, props }) {
    if (!el) {
      console.error(
        "Missing root element.\n\n" +
          "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
          'Consider moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.',
      )
      return
    }
    if (el.dataset.serverRendered === "true") {
      hydrate(App, { target: el, props })
    } else {
      mount(App, { target: el, props })
    }
  },

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
  },

  progress: {
    color: "#4B5563",
  },
})

initializeTheme()
